import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_ONE_PROFESSIONAL_HOTLINE_REQUEST_MESSAGE_FILE = 'API_GET_ONE_PROFESSIONAL_HOTLINE_REQUEST_MESSAGE_FILE';
/**
 * ホットライン メッセージ添付ファイルの取得
 */
export const apiGetOneProfessionalHotlineRequestMessageFile = ({ path }, meta) => apiGetList(API_GET_ONE_PROFESSIONAL_HOTLINE_REQUEST_MESSAGE_FILE, `/professional/hotline/${path.id}/request/${path.hotline_request_id}/message/${path.hotline_request_message_file_id}`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
